import type { JobStatus } from '@jarvis/shared';

export const JOB_STATUS: Record<JobStatus, { label: string; cls: string }> = {
  queued: { label: 'Na fila', cls: 'badge-off' },
  running: { label: 'Executando', cls: 'badge-info' },
  waiting: { label: 'Aguarda você', cls: 'badge-warn' },
  done: { label: 'Concluída', cls: 'badge-signal' },
  failed: { label: 'Falhou', cls: 'badge-danger' }
};
